export const YesNoOptions = [
	{ value: null, text: "" },
	{ value: true, text: "Yes" },
	{ value: false, text: "No" },
];
